<template>
    <div class="fullscreen row flex items-center justify-center">
        <div class="col flex items-center justify-center">
            <div class="q-gutter-sm text-center" style="max-width: 500px;">
                <template v-if="verified">
                    <q-icon name="fas fa-check-circle" size="80px" color="positive" />
                    <h1 class="text-h3 text-weight-bold q-my-none q-mt-md text-positive">Email verificata!</h1>
                    <p class="text-h6 text-grey-7 q-my-md">
                        Il tuo indirizzo email è stato verificato con successo.
                    </p>
                    <q-btn size="lg" color="accent" class="q-px-lg text-weight-bolder q-mt-md" to="/auth/login">
                        Vai al login
                    </q-btn>
                </template>
                <template v-else>
                    <q-icon name="fas fa-exclamation-triangle" size="80px" color="warning" />
                    <h1 class="text-h3 text-weight-bold q-my-none q-mt-md text-warning">Link non valido o scaduto</h1>
                    <p class="text-h6 text-grey-7 q-my-md">
                        Il link di verifica non è valido o è scaduto.
                    </p>
                    <q-btn size="lg" color="accent" class="q-px-lg text-weight-bolder q-mt-md" to="/auth/login">
                        Richiedi un nuovo link
                    </q-btn>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'EmailVerify',

  computed: {
    verified () {
      return this.$route.query.verified === '1'
    }
  }
}
</script>
